import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthCard } from "@/pages/admin/ResetPassword";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthCard title="Reset your password" testid="admin-forgot-page">
      {message ? (
        <p className="text-sm text-foreground mb-6" data-testid="admin-forgot-success">{message}</p>
      ) : (
        <form onSubmit={onSubmit} data-testid="admin-forgot-form">
          <p className="text-sm text-muted-foreground mb-6">
            Enter your sign-in email. We'll send a reset link to your backup email, or to your sign-in email if you haven't set a backup.
          </p>
          <label className="block mb-5">
            <span className="block text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mb-2">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-swiss" data-testid="admin-forgot-email" />
          </label>
          {error && <div className="mb-5 text-sm text-destructive" data-testid="admin-forgot-error">{error}</div>}
          <button type="submit" disabled={submitting} className="btn-primary w-full disabled:opacity-60" data-testid="admin-forgot-submit">
            {submitting ? "Sending..." : "Send reset link"}
          </button>
        </form>
      )}
      <Link to="/admin/login" className="mt-6 inline-block text-xs text-execution hover:underline" data-testid="admin-forgot-back-login">
        Back to sign in
      </Link>
    </AuthCard>
  );
}
